import Vue from 'vue'
import { GET_PRESENCES, ERROR_XHR } from '../mutation-types.js'

export const getPresences = ({ state, dispatch }) => {
  return new Promise((resolve, reject) => {
    Vue.http.get('presence')
    .then(
      (response) => {
        dispatch(GET_PRESENCES, response.json())
        resolve()
      },
      (response) => {
        dispatch(ERROR_XHR, response.json())
        reject()
      }
    )
  })
}



// WEBPACK FOOTER //
// ./src/vuex/actions/presenceActions.js